<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Dados da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula: </label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <!-- Duplicações adicionais -->
              <div v-for="(dup, dupIndex) in duplicacoesAdicionais" :key="dup._key">
                <v-card outlined class="mb-4">
                  <v-card-title class="subtitle-2 primary--text py-2 px-4">
                    Aula {{ dupIndex + 2 }}
                    <v-spacer />
                    <v-btn icon x-small color="error" @click="removerDuplicacao(dupIndex)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-dialog v-model="dup.modal" width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <e-label>Data da Aula</e-label>
                            <v-text-field
                              dense
                              outlined
                              v-model="dup.dataDisplay"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="dup.data"
                            :allowed-dates="allowedDates"
                            scrollable
                            locale="pt-BR"
                          >
                            <v-spacer />
                            <v-btn text color="error" @click="dup.modal = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="confirmarDataDuplicacao(dupIndex)"
                              >Confirmar</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-alert v-if="dup.temConflito" dense outlined type="warning" class="mt-2 mb-0">
                      Já existe uma aula cadastrada para esta data.
                    </v-alert>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Botão Adicionar Aula -->
              <div class="d-flex align-center mb-6">
                <v-btn
                  color="primary"
                  depressed
                  small
                  :disabled="limiteAtingido"
                  @click="adicionarDuplicacao"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  ADICIONAR AULA
                </v-btn>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>O LIMITE MÁXIMO PARA DUPLICAÇÃO DE AULA SÃO DE 5 AULAS.</span>
                </v-tooltip>
                <span
                  v-if="limiteAtingido"
                  class="ml-3 error--text text-caption font-weight-medium"
                >
                  VOCÊ ATINGIU O LIMITE DE 5 AULAS
                </span>
              </div>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Experiências
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <p>
                        {{ rotina.experiencias?.join(",  ") || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Direitos de Aprendizagem
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <ul>
                        <li v-for="campo in rotina.direitos_aprendizagem" :key="campo">
                          {{ campo || "- - -" }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Campos de experiências
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>

                      <ul>
                        <li v-for="campo in rotina.campos_experiencia_aula" :key="campo">
                          {{ campo || "- - -" }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Objetivos de Aprendizagem e Desenvolvimento
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.objetivos_aprendizagem || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Orientações Metodológicas
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.orientacoes_metodologicas || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Recursos
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <ul>
                    <li v-for="rotina in aulaDuplicada.rotinas" :key="rotina.id">
                      <strong>{{ rotina.descricao }}</strong>
                      <p>
                        {{ rotina.recursos || "- - -" }}
                      </p>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>

              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Avaliação
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="content-box">
                  <div>{{ aulaDuplicada.avaliacao }}</div>
                </v-card-text>
              </v-card>

              <v-divider class="my-6"></v-divider>
              <e-progresso-preenchimento
                :expectedItems="itemsProgresso"
                :filledItems="itemsPreenchidos"
                @total-filled-changed="
                  (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                "
                :isInfantil="aulaDuplicada.e_aula_infantil === 1"
              />

              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  depressed
                  :disabled="
                    !totalmentePreenchido ||
                    temConflito ||
                    duplicacoesAdicionais.some((d) => d.temConflito)
                  "
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>
<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
  },
  data() {
    return {
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosFiltrados: [],
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [{ label: "Data", value: "dataAulaDuplicada" }],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      duplicacoesAdicionais: [],
    };
  },
  computed: {
    limiteAtingido() {
      return this.duplicacoesAdicionais.length >= 4;
    },
    itemsProgresso() {
      if (this.duplicacoesAdicionais.length === 0) return this.itemsEsperados;
      const total = 1 + this.duplicacoesAdicionais.length;
      const currentData =
        (this.dataAulaDuplicada ? 1 : 0) +
        this.duplicacoesAdicionais.reduce((sum, d) => sum + (d.data ? 1 : 0), 0);
      return [
        { label: "Data", value: "dataAulaDuplicada", count: { current: currentData, total } },
      ];
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        this.horariosFiltrados = [];
        return;
      }
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
      this.verificarConflitoAula();
    },
    dialog: {
      handler(val) {
        if (!val) {
          this.dataAulaDuplicada = null;
          this.data = null;
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.duplicacoesAdicionais = [];
          this.itemsPreenchidos = [];
        }
      },
    },
  },
  created() {
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  methods: {
    adicionarDuplicacao() {
      if (this.limiteAtingido) return;
      const key = Date.now();
      const idx = this.duplicacoesAdicionais.length;
      this.duplicacoesAdicionais.push({
        _key: key,
        modal: false,
        data: null,
        dataDisplay: null,
        temConflito: false,
      });
    },
    removerDuplicacao(idx) {
      this.duplicacoesAdicionais.splice(idx, 1);
    },
    confirmarDataDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data) return;
      const emUsoEmOutraLinha = this.duplicacoesAdicionais.some(
        (d, i) => i !== idx && d.data === dup.data
      );
      const emUsoNaLinhaPrimaria = this.dataAulaDuplicada === dup.data;
      if (emUsoEmOutraLinha || emUsoNaLinhaPrimaria) {
        this.$toast.danger("Esta data já está sendo usada em outra aula desta duplicação.");
        dup.data = null;
        dup.dataDisplay = null;
        dup.modal = false;
        return;
      }
      const date = new Date(dup.data);
      dup.dataDisplay = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      dup.modal = false;
      this.verificarConflitoDuplicacao(idx);
    },
    async verificarConflitoDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data || !this.aulaDuplicada?.turma_id) {
        dup.temConflito = false;
        return;
      }
      try {
        const response = await this.$services.aulasService.getAulasInfantisEmConflito(
          dup.data,
          this.aulaDuplicada.turma_id
        );
        if ((response.data?.length ?? 0) > 0) {
          dup.temConflito = true;
          this.aulasEmConflito = response.data;
          this.sheetAulasEmConflito = true;
        } else {
          dup.temConflito = false;
        }
      } catch (error) {
        dup.temConflito = false;
      }
    },
    async verificarConflitoAula() {
      if (!this.dataAulaDuplicada || !this.aulaDuplicada?.turma_id) {
        this.aulasEmConflito = [];
        this.sheetAulasEmConflito = false;
        this.temConflito = false;
        return;
      }
      try {
        const response = await this.$services.aulasService.getAulasInfantisEmConflito(
          this.dataAulaDuplicada,
          this.aulaDuplicada.turma_id
        );
        if (response.data?.length > 0) {
          this.aulasEmConflito = response.data;
          this.sheetAulasEmConflito = true;
          this.temConflito = true;
        } else {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }
        let horariosDoDia = [];
        if (diaDaSemana === 5) {
          const todosHorarios = await this.$services.horariosService.horariosAll();
          horariosDoDia = todosHorarios;
        } else {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }
        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },
    enableSubmit() {
      if (this.data) {
        const dupInvalida = this.duplicacoesAdicionais.some((dup) => !dup.data);
        if (dupInvalida) {
          this.$toast.danger("Por favor, preencha a data de todas as aulas adicionadas.");
          return;
        }
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      } else {
        this.$toast.danger("Por favor, preencha todos os campos");
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando as Aulas");
      try {
        const basePayload = {
          ...this.aulaDuplicada,
          horario_inicial: this.horarioSelecionado?.inicio ?? null,
          horario_final: this.horarioSelecionado?.final ?? null,
          horario_id: this.horarioSelecionado?.id ?? null,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
          disciplina_id: this.gestaoDeAulas.disciplina_id,
          turma_id: this.gestaoDeAulas.turma_id,
          instrutor_id: this.gestaoDeAulas.instrutor_id,
        };

        // Cria aula principal
        await this.$services.aulasService.criar(basePayload);

        await this.duplicacoesAdicionais.reduce(
          (chain, dup) =>
            chain.then(() =>
              this.$services.aulasService.criar({
                ...basePayload,
                data: dup.data,
              })
            ),
          Promise.resolve()
        );

        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        const total = 1 + this.duplicacoesAdicionais.length;
        this.$toast.success(
          total === 1 ? "Aula duplicada com sucesso!" : `${total} aulas duplicadas com sucesso!`
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>
<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
.content-box {
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
</style>
